import * as pb from "../rpc/shopaholic/shopaholic";
import { twirpClient } from "./client";

// findProductToken returns a token that contains information about the product matching the supplied SKU.
export async function findProductToken(origin: string, sku: string): Promise<string> {
  const client = new pb.ProductsClientImpl(twirpClient);
  const { token } = await client.FindProductToken({ sku, origin });
  return token;
}
